<template>
    <div>
        <div class="container">
            <div class="row">
                <!-- <h3 class="mb-4">{{this.$t('sistemi_prokurorial.raports.title')}}</h3> -->
                <titleArea :title="$t('sistemi_prokurorial.raports.title')" />
            </div>
            <div class="row g-4">
                <div class="col-lg-3 col-md-6 col-sm-6" v-for="item in fetchReportsFormated" :key="item.id"
                    @click.capture="openReportFile($event, item)">
                    <RaportCardTemplate :date_post="item.data_post" :title="item.title" :description="item.description"
                        :buton="item.id" :id="item.id" />
                </div>
            </div>
            <div class="row">
                <button @click="$router.push('/raports')" class="show_all">{{this.$t('sistemi_prokurorial.raports.button')}}</button>
            </div>
        </div>

    </div>
</template>
<script>
import { usePostsStore } from '@/store/PostStore/postStore';
import RaportCardTemplate from '../share/RaportCard.vue'
import titleArea from '../share/TitleArea.vue';
export default {
    data(){
        return {
            postStore: usePostsStore(),
            webPage: '',
            language: 'AL',
            count: 4,
            categoryId: 37,
        }
    },
    components: {
        RaportCardTemplate,
        titleArea
    },

    computed: {

        fetchReportsFormated(){
            return this.postStore.raportetPosts.map(post => ({
                id: post.id,
                data_post: post.createdDate,
                title: post.priceDetailsTitle,
                description: post.priceDetailsTitle,
                fileUrl: this.getPdfFileUrl(post.pDetailsFileUrl),
                more_button: "#GO"
            }))
        }
    },

    created(){
        this.fetchPostReports();
    },

    methods: {
        fetchPostReports(){
            const postData = {
                webPage: this.webPage,
                language: this.language,
                count: this.count,
                categoryId: this.categoryId,
            };
            this.postStore.getRaportetPosts(postData);
        },
        getPdfFileUrl(fileUrl){
            if (!fileUrl || !fileUrl.toLowerCase().split('?')[0].endsWith('.pdf')) {
                return '';
            }

            if (/^https?:\/\//i.test(fileUrl)) {
                return fileUrl;
            }

            return `https://prokuroria-rks.org/uploads/${fileUrl}`;
        },
        openReportFile(event, item){
            if (!event.target.closest('.moreButton') || !item.fileUrl) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            window.open(item.fileUrl, '_blank');
        },
    }
 
}
</script>
<style scoped>
.show_all {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0%;
    color: #FFFFFF;
    background: #2C3F5E;
    border-radius: 8px;
    padding: 10px 16px;
    text-decoration: none;
    width: 156px;
    margin: 0 auto;
    margin-top: 32px;
}


</style>
